import { GeneralSearchComponent } from './general-search.component';
import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '../../../translate/translate.module';

@NgModule({
  declarations: [GeneralSearchComponent],
  imports: [
    CommonModule, IonicModule, TranslateModule
  ],
  exports: [GeneralSearchComponent]
})
export class GeneralSearchModule { }
